import tzdata from "tzdata";
const keys = Object.keys(tzdata.zones).sort();
const timeZones = keys.map(x => {
    return { text: x, value: x };
});
export default timeZones;